import styled from 'styled-components';

export const HeroSection = styled.section`
  width: 100%;

  padding-bottom: var(--space-xxxl);
`;

export const HeroContainer = styled.div`
  width: min(100%, 1280px);

  margin: 0 auto;
`;

export const HeroTop = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(320px, 0.7fr);
  align-items: center;
  gap: clamp(var(--space-xxl), 6vw, var(--space-xxxxxl));

  @media screen and (max-width: 950px) {
    grid-template-columns: 1fr;
    gap: var(--space-xxl);
  }
`;

export const HeroContent = styled.div`
  width: 100%;
  max-width: 760px;
`;

export const HeroEyebrow = styled.p`
  margin: 0 0 var(--space-s);

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 0.76rem;
  line-height: 1.4;
  font-weight: 800;

  text-transform: uppercase;
  letter-spacing: 0.15em;
`;

export const HeroTitle = styled.h1`
  max-width: 820px;

  margin: 0;

  color: var(--grey7);

  font-size: clamp(2.8rem, 5.1vw, 4.9rem);
  line-height: 0.98;
  font-weight: 800;

  letter-spacing: -0.05em;

  @media screen and (max-width: 650px) {
    font-size: clamp(2.5rem, 12vw, 3.8rem);
    line-height: 1;
  }
`;

export const HeroDescription = styled.p`
  max-width: 680px;

  margin: var(--space-xl) 0 0;

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: clamp(1rem, 1.4vw, 1.08rem);
  line-height: 1.8;
  font-weight: 500;

  @media screen and (max-width: 650px) {
    margin-top: var(--space-l);

    line-height: 1.7;
  }
`;

export const TrainingPanel = styled.aside`
  width: 100%;

  padding: var(--space-l);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadiusLarge);

  background: var(--white);

  box-shadow:
    0 20px 52px rgba(23, 23, 23, 0.07),
    0 3px 10px rgba(23, 23, 23, 0.025);

  @media screen and (max-width: 950px) {
    max-width: 680px;
  }
`;

export const TrainingPanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-m);
`;

export const TrainingPanelIcon = styled.span`
  width: 44px;
  height: 44px;

  flex-shrink: 0;

  display: grid;
  place-items: center;

  border: 1px solid rgba(230, 139, 7, 0.18);
  border-radius: var(--borderRadius);

  background: var(--yellow1);

  color: var(--orange5);

  font-size: 1rem;
  line-height: 0;

  svg {
    width: 17px;
    height: 17px;

    display: block;
  }
`;

export const TrainingPanelEyebrow = styled.p`
  margin: 0 0 var(--space-xxs);

  color: var(--orange5);

  font-family: var(--mainFont);
  font-size: 0.67rem;
  line-height: 1.4;
  font-weight: 800;

  text-transform: uppercase;
  letter-spacing: 0.12em;
`;

export const TrainingPanelTitle = styled.h2`
  margin: 0;

  color: var(--grey7);

  font-size: clamp(1.45rem, 2.4vw, 1.9rem);
  line-height: 1.06;
  font-weight: 800;

  letter-spacing: -0.035em;
`;

export const TrainingPanelDescription = styled.p`
  margin: var(--space-m) 0 0;

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 0.88rem;
  line-height: 1.65;
  font-weight: 500;
`;

export const TrainingOptions = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-s);

  margin-top: var(--space-l);

  @media screen and (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`;

export const TrainingOption = styled.div`
  min-width: 0;

  display: flex;
  align-items: flex-start;
  gap: var(--space-s);

  padding: var(--space-s);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadius);

  background: var(--cardBackground);
`;

export const TrainingOptionIcon = styled.span`
  width: 30px;
  height: 30px;

  flex-shrink: 0;

  display: grid;
  place-items: center;

  border-radius: 50%;

  background: var(--yellow1);

  color: var(--orange5);

  font-size: 0.72rem;
  line-height: 0;

  svg {
    width: 13px;
    height: 13px;

    display: block;
  }
`;

export const TrainingOptionText = styled.div`
  min-width: 0;

  strong {
    display: block;

    color: var(--grey7);

    font-family: var(--mainFont);
    font-size: 0.8rem;
    line-height: 1.3;
    font-weight: 800;
  }

  span {
    display: block;

    margin-top: var(--space-xxxs);

    color: var(--grey4);

    font-family: var(--mainFont);
    font-size: 0.7rem;
    line-height: 1.4;
    font-weight: 500;
  }
`;

export const SearchArea = styled.div`
  width: 100%;

  position: relative;

  margin-top: var(--space-xxxl);
`;

export const SearchToolbar = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: var(--space-m);
  align-items: stretch;

  @media screen and (max-width: 650px) {
    grid-template-columns: 1fr;
  }
`;

export const SearchBox = styled.div`
  min-width: 0;
  min-height: 58px;

  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: var(--space-s);

  padding: 0 var(--space-m);

  border: 1px solid var(--grey1);
  border-radius: var(--borderRadiusLarge);

  background: var(--white);

  box-shadow:
    0 12px 32px rgba(23, 23, 23, 0.045),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);

  transition:
    border-color 180ms ease,
    box-shadow 180ms ease;

  &:focus-within {
    border-color: rgba(230, 139, 7, 0.45);

    box-shadow:
      0 14px 36px rgba(23, 23, 23, 0.06),
      0 0 0 3px rgba(230, 139, 7, 0.08);
  }
`;

export const SearchIcon = styled.span`
  display: grid;
  place-items: center;

  color: var(--grey3);

  font-size: 1.05rem;
  line-height: 0;

  svg {
    display: block;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  min-width: 0;

  padding: var(--space-m) 0;

  border: 0;
  box-shadow: none;
  outline: 0;

  background: transparent;

  color: var(--grey7);

  font-family: var(--mainFont);
  font-size: 1rem;
  line-height: 1.4;
  font-weight: 500;

  appearance: none;

  &::placeholder {
    color: var(--grey3);
    opacity: 1;
  }

  &::-webkit-search-cancel-button {
    display: none;
  }
`;

export const ClearSearchButton = styled.button`
  width: 32px;
  height: 32px;

  display: grid;
  place-items: center;

  padding: 0;

  border: 0;
  border-radius: 50%;

  background: var(--grey15);

  color: var(--grey4);

  font-size: 0.9rem;
  line-height: 0;

  cursor: pointer;

  transition:
    background-color 180ms ease,
    color 180ms ease;

  svg {
    display: block;
  }

  &:hover {
    background: var(--yellow1);

    color: var(--orange5);
  }

  &:focus-visible {
    outline: 2px solid var(--orange5);
    outline-offset: 2px;
  }
`;

export const FilterWrap = styled.div`
  position: relative;
`;

export const FilterButton = styled.button`
  min-width: 136px;
  min-height: 58px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-s);

  padding: 0 var(--space-l);

  border: 1px solid
    ${({ $active }) => ($active ? 'rgba(230, 139, 7, 0.35)' : 'var(--grey1)')};
  border-radius: var(--borderRadiusLarge);

  background: ${({ $active }) => ($active ? 'var(--yellow1)' : 'var(--white)')};

  color: ${({ $active }) => ($active ? 'var(--grey7)' : 'var(--grey6)')};

  font-family: var(--mainFont);
  font-size: 0.94rem;
  line-height: 1;
  font-weight: 800;

  cursor: pointer;

  box-shadow: 0 12px 32px rgba(23, 23, 23, 0.045);

  transition:
    background-color 180ms ease,
    border-color 180ms ease,
    color 180ms ease,
    transform 180ms ease;

  svg {
    flex-shrink: 0;

    font-size: 1rem;
  }

  &:hover {
    border-color: rgba(230, 139, 7, 0.35);

    background: var(--yellow1);

    color: var(--grey7);

    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid var(--orange5);
    outline-offset: 3px;
  }

  @media screen and (max-width: 650px) {
    width: 100%;
  }
`;

export const FilterCount = styled.span`
  min-width: 22px;
  height: 22px;

  display: grid;
  place-items: center;

  padding: 0 var(--space-xxs);

  border-radius: 50%;

  background: var(--orange5);

  color: var(--white);

  font-size: 0.72rem;
  line-height: 1;
  font-weight: 800;
`;

export const FilterPopover = styled.div`
  width: min(340px, calc(100vw - var(--space-xl)));

  position: absolute;
  top: calc(100% + var(--space-s));
  right: 0;

  z-index: 40;

  padding: var(--space-m);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadiusLarge);

  background: var(--white);

  box-shadow:
    0 24px 60px rgba(23, 23, 23, 0.14),
    0 4px 12px rgba(23, 23, 23, 0.05);

  @media screen and (max-width: 650px) {
    right: auto;
    left: 0;

    width: 100%;
  }
`;

export const PopoverHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-m);

  padding-bottom: var(--space-m);

  border-bottom: 1px solid var(--grey15);

  span {
    display: block;

    margin-bottom: var(--space-xxxs);

    color: var(--orange5);

    font-family: var(--mainFont);
    font-size: 0.65rem;
    line-height: 1.4;
    font-weight: 800;

    text-transform: uppercase;
    letter-spacing: 0.11em;
  }

  h3 {
    margin: 0;

    color: var(--grey7);

    font-size: 1.1rem;
    line-height: 1.3;
    font-weight: 800;
  }
`;

export const PopoverCloseButton = styled.button`
  width: 32px;
  height: 32px;

  flex-shrink: 0;

  display: grid;
  place-items: center;

  padding: 0;

  border: 1px solid var(--grey);
  border-radius: 50%;

  background: var(--white);

  color: var(--grey4);

  line-height: 0;

  cursor: pointer;

  transition:
    background-color 180ms ease,
    color 180ms ease;

  &:hover {
    background: var(--grey15);

    color: var(--grey7);
  }
`;

export const TagSearchInput = styled.input`
  width: 100%;

  margin-top: var(--space-m);
  padding: var(--space-s) var(--space-m);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadiusSmall);

  background: var(--cardBackground);

  color: var(--grey7);

  font-family: var(--mainFont);
  font-size: 0.88rem;
  line-height: 1.4;
  font-weight: 500;

  outline: 0;

  &::placeholder {
    color: var(--grey3);
  }

  &:focus {
    border-color: rgba(230, 139, 7, 0.4);

    box-shadow: 0 0 0 3px rgba(230, 139, 7, 0.08);
  }

  &::-webkit-search-cancel-button {
    display: none;
  }
`;

export const TagList = styled.ul`
  max-height: 260px;

  display: flex;
  flex-direction: column;
  gap: var(--space-xxs);

  margin: var(--space-m) 0 0;
  padding: 0;

  overflow-y: auto;

  li {
    list-style: none;
  }
`;

export const TagOption = styled.button`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-s);

  padding: 0.7rem var(--space-s);

  border: 1px solid
    ${({ $active }) => ($active ? 'rgba(230, 139, 7, 0.2)' : 'transparent')};
  border-radius: var(--borderRadiusSmall);

  background: ${({ $active }) =>
    $active ? 'rgba(255, 240, 194, 0.7)' : 'transparent'};

  color: ${({ $active }) => ($active ? 'var(--grey7)' : 'var(--grey5)')};

  font-family: var(--mainFont);
  font-size: 0.86rem;
  line-height: 1.4;
  font-weight: ${({ $active }) => ($active ? 800 : 600)};

  text-align: left;

  cursor: ${({ as }) => (as === 'div' ? 'default' : 'pointer')};

  transition:
    background-color 180ms ease,
    border-color 180ms ease,
    color 180ms ease;

  &:hover {
    background: var(--grey15);

    color: var(--grey7);
  }
`;

export const TagOptionCheck = styled.span`
  width: 22px;
  height: 22px;

  flex-shrink: 0;

  display: grid;
  place-items: center;

  border-radius: 50%;

  background: var(--orange5);

  color: var(--white);

  font-size: 0.7rem;
  line-height: 0;

  svg {
    display: block;
  }
`;

export const PopoverFooter = styled.div`
  margin-top: var(--space-m);
  padding-top: var(--space-m);

  border-top: 1px solid var(--grey15);
`;

export const ClearButton = styled.button`
  width: 100%;

  padding: var(--space-s) var(--space-m);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadiusButton);

  background: var(--white);

  color: var(--grey6);

  font-family: var(--mainFont);
  font-size: 0.82rem;
  line-height: 1.3;
  font-weight: 800;

  cursor: pointer;

  transition:
    background-color 180ms ease,
    border-color 180ms ease,
    color 180ms ease;

  &:hover:not(:disabled) {
    border-color: rgba(230, 139, 7, 0.3);

    background: var(--yellow1);

    color: var(--grey7);
  }

  &:disabled {
    cursor: not-allowed;

    opacity: 0.45;
  }
`;

export const ActiveFilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-s);

  margin-top: var(--space-m);
`;

export const ActiveFilterLabel = styled.span`
  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 0.8rem;
  line-height: 1.4;
  font-weight: 700;
`;

export const ActiveChip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);

  padding: 0.45rem 0.7rem;

  border: 1px solid rgba(230, 139, 7, 0.22);
  border-radius: var(--borderRadiusButton);

  background: var(--yellow1);

  color: var(--grey7);

  font-family: var(--mainFont);
  font-size: 0.78rem;
  line-height: 1.2;
  font-weight: 800;

  cursor: pointer;

  svg {
    font-size: 0.8rem;
  }

  &:hover {
    border-color: var(--orange5);
  }
`;

export const PartTwoNote = styled.div`
  width: fit-content;
  max-width: 820px;

  display: flex;
  align-items: center;
  gap: var(--space-s);

  margin-top: var(--space-m);
  padding: var(--space-s) var(--space-m);

  border: 1px solid var(--grey);
  border-radius: var(--borderRadius);

  background: var(--cardBackground);

  @media screen and (max-width: 650px) {
    width: 100%;

    align-items: flex-start;
  }
`;

export const PartTwoBadge = styled.span`
  flex-shrink: 0;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 0.35rem 0.65rem;

  border: 1px solid var(--yellow5);
  border-radius: var(--borderRadiusButton);

  background: var(--yellow1);

  color: var(--grey7);

  font-family: var(--mainFont);
  font-size: 0.7rem;
  line-height: 1;
  font-weight: 800;

  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const PartTwoText = styled.p`
  margin: 0;

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 0.84rem;
  line-height: 1.55;
  font-weight: 500;
`;
